(function () {
  const ACTIVE_CLASS = 'is-active';
  const HOVER_CLASS = 'is-hovered';
  const SELECTED_CLASS = 'is-selected';
  const MARKER_CLASS = 'ctr-athletes-map__marker';
  const TOOLTIP_CARD_SELECTOR = '[data-tooltip-athlete-index]';
  const PREVIEW_STAT_ICON = `
    <span class="ctr-athletes-map__preview-stat-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.3946 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.5 1.5L6 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.5 1.5H10.5V4.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  `;

  const normalizeStateId = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[.'"]/g, '')
      .replace(/[\s-]+/g, '_');

  const formatStateName = (value) =>
    String(value || '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const getStateCode = (value) => String(value || '').trim().toUpperCase();

  const clearStateClasses = (paths, markers, className) => {
    paths.forEach((path) => path.classList.remove(className));
    markers.forEach((marker) => marker.classList.remove(className));
  };

  const buildMarker = (statesRoot, path) => {
    const bbox = path.getBBox();
    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    const stateCode = getStateCode(path.dataset.id || path.id);

    circle.setAttribute('class', MARKER_CLASS);
    circle.setAttribute('cx', bbox.x + bbox.width / 2);
    circle.setAttribute('cy', bbox.y + bbox.height / 2);
    circle.setAttribute('r', 6.65);
    circle.dataset.stateId = stateCode;

    statesRoot.appendChild(circle);

    return circle;
  };

  const initMap = (section) => {
    if (section.dataset.initialized === 'true') return;

    const mapCanvas = section.querySelector('[data-map-canvas]');
    const svg = mapCanvas ? mapCanvas.querySelector('svg') : null;
    const statesRoot = svg || null;

    if (!svg || !statesRoot) return;

    section.dataset.initialized = 'true';

    const countEl = section.querySelector('[data-active-count]');
    const previewImageEl = section.querySelector('[data-preview-image]');
    const previewSchoolEl = section.querySelector('[data-preview-school]');
    const previewStatEl = section.querySelector('[data-preview-stat]');
    const previewLinkEl = section.querySelector('[data-preview-link]');
    const previewMilestoneEl = section.querySelector('[data-preview-milestone]');
    const previewCopyEl = section.querySelector('[data-preview-copy]');
    const tooltip = section.querySelector('[data-map-tooltip]');
    const tooltipListEl = section.querySelector('[data-tooltip-list]');
    const tooltipClose = section.querySelector('[data-tooltip-close]');
    const dataNode = document.getElementById(`athletes-map-data-${section.dataset.sectionId}`);
    const emptyPreviewTitle = section.dataset.emptyStateTitle || '';
    const emptyPreviewSchool = previewSchoolEl ? previewSchoolEl.textContent : '';
    const emptyPreviewMilestone = previewMilestoneEl ? previewMilestoneEl.innerHTML : '';
    const emptyPreviewCopy = previewCopyEl ? previewCopyEl.textContent : '';
    const athletes = dataNode ? JSON.parse(dataNode.textContent || '[]') : [];
    const statePaths = Array.from(statesRoot.querySelectorAll('path[data-id]'));
    const stateNameToCode = statePaths.reduce((accumulator, path) => {
      const stateName = normalizeStateId(path.dataset.name);
      const stateCode = getStateCode(path.dataset.id || path.id);

      if (stateName && stateCode) accumulator[stateName] = stateCode;

      return accumulator;
    }, {});
    const stateCodeToName = statePaths.reduce((accumulator, path) => {
      const stateCode = getStateCode(path.dataset.id || path.id);
      const stateName = path.dataset.name || formatStateName(path.id);

      if (stateCode) accumulator[stateCode] = stateName;

      return accumulator;
    }, {});
    const resolveAthleteStateCode = (athlete) => {
      const handle = String(athlete.state_handle || '').trim();
      const stateName = normalizeStateId(athlete.state);

      if (handle.length === 2) return getStateCode(handle);
      if (stateNameToCode[stateName]) return stateNameToCode[stateName];
      if (stateNameToCode[normalizeStateId(handle)]) return stateNameToCode[normalizeStateId(handle)];

      return '';
    };
    const getStateDisplayName = (stateCode) => stateCodeToName[getStateCode(stateCode)] || formatStateName(stateCode);
    const athletesByState = athletes.reduce((accumulator, athlete) => {
      const stateCode = resolveAthleteStateCode(athlete);

      if (!stateCode) return accumulator;

      if (!accumulator[stateCode]) accumulator[stateCode] = [];
      accumulator[stateCode].push(athlete);

      return accumulator;
    }, {});
    const activePaths = [];
    const markersById = new Map();
    let selectedId = '';
    let lastPreviewStateId = '';
    let lastPreviewAthlete = null;

    statePaths.forEach((path) => {
      const stateCode = getStateCode(path.dataset.id || path.id);

      if (!athletesByState[stateCode] || !athletesByState[stateCode].length) return;

      path.classList.add(ACTIVE_CLASS);
      path.dataset.stateId = stateCode;
      path.setAttribute('tabindex', '0');
      path.setAttribute('role', 'button');
      path.setAttribute('aria-label', getStateDisplayName(stateCode));

      activePaths.push(path);
      markersById.set(stateCode, buildMarker(statesRoot, path));
    });

    const getStateAthletes = (stateId) => {
      return athletesByState[getStateCode(stateId)] || [];
    };

    const getPrimaryAthlete = (stateId) => getStateAthletes(stateId)[0] || null;

    if (countEl) countEl.textContent = Object.keys(athletesByState).length;

    const updatePreview = (stateId, athleteOverride = null) => {
      if (!previewCopyEl || !previewSchoolEl || !previewStatEl || !previewLinkEl || !previewMilestoneEl || !previewImageEl) return;

      if (!stateId) {
        previewSchoolEl.textContent = emptyPreviewSchool || emptyPreviewTitle;
        previewStatEl.hidden = true;
        previewStatEl.innerHTML = '';
        previewStatEl.href = '#';
        previewLinkEl.href = '#';
        previewMilestoneEl.innerHTML = emptyPreviewMilestone;
        previewCopyEl.textContent = emptyPreviewCopy;
        previewImageEl.hidden = true;
        previewImageEl.removeAttribute('src');
        previewImageEl.alt = '';
        return;
      }

      const athlete = athleteOverride || getPrimaryAthlete(stateId);

      lastPreviewStateId = stateId;
      lastPreviewAthlete = athlete || null;

      previewSchoolEl.textContent = athlete && athlete.school ? athlete.school : getStateDisplayName(stateId);
      previewCopyEl.textContent = athlete && athlete.bio ? athlete.bio : emptyPreviewCopy;
      previewStatEl.href = athlete && athlete.url ? athlete.url : '#';
      previewLinkEl.href = athlete && athlete.url ? athlete.url : '#';
      previewMilestoneEl.innerHTML = athlete && athlete.milestone_html ? athlete.milestone_html : emptyPreviewMilestone;

      if (athlete && athlete.stat) {
        previewStatEl.hidden = false;
        previewStatEl.innerHTML = `<span class="ctr-athletes-map__preview-stat-text">${athlete.stat}</span>${PREVIEW_STAT_ICON}`;
      } else {
        previewStatEl.hidden = true;
        previewStatEl.innerHTML = '';
      }

      if (athlete && athlete.image) {
        previewImageEl.hidden = false;
        previewImageEl.src = athlete.image;
        previewImageEl.alt = athlete.name || getStateDisplayName(stateId);
      } else {
        previewImageEl.hidden = true;
        previewImageEl.removeAttribute('src');
        previewImageEl.alt = '';
      }
    };

    const placeTooltip = (path, stateId) => {
      if (!tooltip || !tooltipListEl) return;

      const mapRect = mapCanvas.getBoundingClientRect();
      const pathRect = path.getBoundingClientRect();
      const centerX = pathRect.left - mapRect.left + pathRect.width / 2;
      const bottomY = pathRect.top - mapRect.top + pathRect.height;
      const stateAthletes = getStateAthletes(stateId);

      tooltipListEl.innerHTML = stateAthletes
        .map((athlete, index) => {
          const imageMarkup = athlete && athlete.image
            ? `<div class="ctr-athletes-map__tooltip-image-wrap"><img class="ctr-athletes-map__tooltip-image" src="${athlete.image}" alt="${athlete.name || getStateDisplayName(stateId)}" loading="lazy"></div>`
            : '';
          const meta = athlete && athlete.role ? athlete.role : '';
          const href = athlete && athlete.url ? athlete.url : '#';

          return `
            <a class="ctr-athletes-map__tooltip-card" data-tooltip-athlete-index="${index}" href="${href}">
              ${imageMarkup}
              <div class="ctr-athletes-map__tooltip-body">
                <h3 class="ctr-athletes-map__tooltip-title">${athlete && athlete.name ? athlete.name : getStateDisplayName(stateId)}</h3>
                <p class="ctr-athletes-map__tooltip-meta">${meta}</p>
              </div>
            </a>
          `;
        })
        .join('');

      tooltip.hidden = false;

      const tooltipWidth = tooltip.offsetWidth;
      const maxLeft = Math.max(12, mapCanvas.clientWidth - tooltipWidth - 12);
      const tooltipLeft = Math.min(maxLeft, Math.max(12, centerX - tooltipWidth / 2));
      const tooltipTop = Math.max(12, bottomY + 12);

      tooltip.style.left = `${tooltipLeft}px`;
      tooltip.style.top = `${tooltipTop}px`;
    };

    const syncPreviewFromTooltipCard = (cardEl) => {
      if (!cardEl || !selectedId) return;

      const athleteIndex = Number(cardEl.dataset.tooltipAthleteIndex);
      const stateAthletes = getStateAthletes(selectedId);
      const athlete = Number.isNaN(athleteIndex) ? null : stateAthletes[athleteIndex];

      if (!athlete) return;

      updatePreview(selectedId, athlete);
    };

    const clearPinnedState = () => {
      selectedId = '';
      clearStateClasses(activePaths, Array.from(markersById.values()), SELECTED_CLASS);
      if (tooltip) tooltip.hidden = true;

      if (lastPreviewStateId) {
        updatePreview(lastPreviewStateId, lastPreviewAthlete);
      }
    };

    const hoverState = (stateId) => {
      clearStateClasses(activePaths, Array.from(markersById.values()), HOVER_CLASS);

      if (!stateId) return;

      const path = activePaths.find((item) => item.dataset.stateId === stateId);
      const marker = markersById.get(stateId);

      if (!path) return;

      path.classList.add(HOVER_CLASS);
      if (marker) marker.classList.add(HOVER_CLASS);
      updatePreview(stateId);

      if (!selectedId) placeTooltip(path, stateId);
    };

    activePaths.forEach((path) => {
      path.addEventListener('mouseenter', () => hoverState(path.dataset.stateId));
      path.addEventListener('mouseleave', () => {
        clearStateClasses(activePaths, Array.from(markersById.values()), HOVER_CLASS);
        if (!selectedId && tooltip) tooltip.hidden = true;
      });

      path.addEventListener('focus', () => hoverState(path.dataset.stateId));
      path.addEventListener('blur', () => {
        clearStateClasses(activePaths, Array.from(markersById.values()), HOVER_CLASS);
      });

      path.addEventListener('click', () => {
        selectedId = path.dataset.stateId;
        clearStateClasses(activePaths, Array.from(markersById.values()), SELECTED_CLASS);
        path.classList.add(SELECTED_CLASS);

        const marker = markersById.get(path.dataset.stateId);
        if (marker) marker.classList.add(SELECTED_CLASS);

        updatePreview(path.dataset.stateId);
        placeTooltip(path, path.dataset.stateId);
      });

      path.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        path.click();
      });
    });

    if (tooltipClose) {
      tooltipClose.addEventListener('click', clearPinnedState);
    }

    if (tooltipListEl) {
      tooltipListEl.addEventListener('mouseover', (event) => {
        const card = event.target.closest(TOOLTIP_CARD_SELECTOR);
        if (!card || !tooltipListEl.contains(card)) return;
        syncPreviewFromTooltipCard(card);
      });

      tooltipListEl.addEventListener('focusin', (event) => {
        const card = event.target.closest(TOOLTIP_CARD_SELECTOR);
        if (!card || !tooltipListEl.contains(card)) return;
        syncPreviewFromTooltipCard(card);
      });
    }

    document.addEventListener('click', (event) => {
      if (!selectedId) return;
      if (section.contains(event.target)) return;
      clearPinnedState();
    });

    if (activePaths[0]) {
      updatePreview(activePaths[0].dataset.stateId);
    } else {
      updatePreview('');
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-athletes-map]').forEach(initMap);
  });
})();
